<template>
  <div class="col-sm-3" style="background-color: white">
    <div class="d-flex justify-content-between">
      <div>Объект</div>
      <div>Выбрать все объекты</div>
    </div>
    <el-select multiple v-model="selectObjects" placeholder="Выберите объект" size="large" class="m-3 mb-5"
               style="width: 90%">
      <el-option
        v-for="(item, index ) in objects"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>
    <div>Выбор показателей</div>
    <el-select multiple v-model="selectIndicators" placeholder="Выберите показатели" size="large" class="m-3 mb-5"
               style="width: 90%">
      <el-option
        v-for="(item, index ) in indicators"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>
    <div class>Выберите месяц и год начала</div>
    <div class="d-flex mb-3">
      <el-select v-model="selectMonthBegin" placeholder="Выберите месяц" size="large" class="m-3"
                 style="width: 40%">
        <el-option
          v-for="(item, index ) in months"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
      <el-select v-model="selectYearBegin" placeholder="Выберите год" size="large" class="m-3"
                 style="width: 40%">
        <el-option
          v-for="(item, index ) in years"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
    </div>
    <div class>Выберите месяц и год начала конца</div>
    <div class="d-flex mb-3 mb-5">
      <el-select v-model="selectMonthEnd" placeholder="Выберите месяц" size="large" class="m-3"
                 style="width: 40%">
        <el-option
          v-for="(item, index ) in months"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
      <el-select v-model="selectYearEnd" placeholder="Выберите год" size="large" class="m-3"
                 style="width: 40%">
        <el-option
          v-for="(item, index ) in years"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
    </div>
    <div class="d-flex flex-column d-flex align-items-center">
      <button type="button" class="btn btn-dark mb-2" style="width: 90%">Сформировать запрос</button>
      <button type="button" class="btn btn-light" style="width: 90%">Сбросить все параметры</button>
    </div>
  </div>
</template>

<script>
    export default {
      name: "ReportSideBar",
      props: {
        places: {type: Array},
        objects: {type: Array},
        indicators: {type: Array},
      },
      data() {
        return {
          selectObjects: [],
          selectIndicators: [],
          months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль",
            "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
          years: [2000, ...Array.from(Array(35).keys(), x => x + 2001)],
          selectMonthBegin: '',
          selectYearBegin: null,
          selectMonthEnd: '',
          selectYearEnd: null,
        }
      }
    }
</script>

<style scoped>

</style>
